import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate} from "react-router-dom";
import Swal from 'sweetalert2';
import helpers from '../../../helpers/helpers';
import appConfig from '../../../config/env';
import store from '../../../helpers/store';
import { httpRequest } from '../../../helpers/httpService';
import Loader from '../../parts/Loader';
import EventCards from '../../parts/EventCards';
import SearchBar from '../../parts/SearchBar';
import Paginations from '../../parts/Paginations';
 
function DashboardClient (){
    const api_url = appConfig.apiUrl;
    const [registered_event_list, setRegisteredEvents] = useState([]);
    const [upcoming_event_list, setEvents] = useState([]);
    const [loading, setLoading] = useState(1);
    const [tab, changeTab] = useState('registered-events');
    const [res_data, setResData] = useState([]);

    // Search
    const [search_key, setSearchKey] = useState('');
    const [search_filter, setFilter] = useState('title');
    
    let navigate = useNavigate();

    useEffect(() => {
        getRegisteredEvents()
        getEvents()
    }, []);

    useEffect(() => {
        
    }, [tab]);

    function getEvents() {

      const url = api_url + '/public/events?filter=upcoming';

      httpRequest(url, "GET")
          .then((res) => {
              setEvents(res.data)
          })
          .catch((err) => {
              //Unauthorize
              if(err.status_code === 401){
                  window.location.href = "/";
              }
          });
    }

    function getRegisteredEvents() {
        //const params = ''
        const params = '?per_page='+store.per_page;
        const url = api_url + '/client/registered-events'+params;
        setLoading(1)

        sendRequest(url, 'registered-events')
    }
    
    function changePage(page) {
        let params = '?per_page='+store.per_page+'&search'+'='+search_key+'&page='+page

        const url = api_url + '/client/registered-events'+params;

        setLoading(1)
        sendRequest(url)
    }

    function handleSearch(){
        let params = search_filter+'='+search_key
        let url = '';

        if(tab == 'all-events'){
            //params += '&filter=upcoming'
            url = api_url + '/public/events?'+params
        }else if(tab == 'registered-events'){
            url = api_url + '/client/registered-events?'+params
        }
    
        setLoading(1)
        sendRequest(url, tab)
    }

    

    function sendRequest(url, tab = 'all-events'){

        httpRequest(url, "GET", {}, true)
        .then((res) => {
            if(tab == 'all-events'){
                setEvents(res.data);
            }else{
                setRegisteredEvents(res.data);
            }
            //paginationItems(res);
            setResData(res)

            setLoading(0)
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                title: "Error!",
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        }); 
    }

    function btnAction(data, action = ''){
        const ref_no = data.reference_no ?? '';

        if(action == 'continue'){
            return navigate('/registration/event/'+data.event_id);
        }
        else if(action == 'update-payment'){
            return navigate('/registration/event/'+data.event_id+'/step-2');
        }
        else if(action == 'pay-now'){
            let message = '';
            const amount = data.amount ?? 0;

            if(!ref_no){
              message = 'Invalid reference number.'
            }else if(!amount && data.status == 4){
              message = 'Event is already registered.'
            }
            else{
                const url = api_url + '/client/payment/'+ref_no;
                setLoading(1)
                httpRequest(url, "POST", {}, true)
                .then((res) => {
                    setLoading(0)

                    if(res.action == 'payment-gateway' && data.payment_method != 3)
                    {
                        let text = ''
                        if(data.payment_method == 1 || data.payment_method == 4){
                            text = 'Pesopay is a secure payment portal which will allow you to safely register your Credit/Debit Card or Gcash details.'
                        }else if(data.payment_method == 2){

                            text = 'Paypal is a secure payment portal which will allow you to safely register your payment details'
                        }
                    
                        Swal.fire({
                            title: 'Redirecting to Payment gateway please wait...',
                            text: text,
                            icon: 'info',
                            allowOutsideClick: false,
                            showCancelButton: false, // There won't be any cancel button
                            showConfirmButton: false // There won't be any confirm button
                            
                        });

                        const body = document.getElementsByTagName("body")[0];
                        const div = document.createElement("div");
                        div.setAttribute("className", "hidden");
                        div.innerHTML = res.form;
                        body.appendChild(div);

                        setTimeout(() => {
                            document.getElementById("payment-gateway").submit();
                        }, 2000);
                    }
                    else{ // Over-the-counter
                        const params = '?status=pending&ref='+res.reference_no+'&e='+data.id+'&d='+res.first_name
                        return navigate("/thankyou/" + params);
                    }
                })
                .catch((err) => {
                    setLoading(0)
                    
                    //Unauthorize
                    if(err.status_code === 401){
                        window.location.href = "/";
                    }

                    Swal.fire({
                        title: "Error!",
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK",
                        allowOutsideClick: false,
                    });
                }); 

                return;
            }

            
            Swal.fire({
                title: 'Error!',
                text: message,
                icon: 'error',
                confirmButtonText: 'Refresh Page',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload(false)
                }
            })
        }
    }

    function tableContent(registered_event_list){
        let row_items = [];

        if (Object.keys(registered_event_list).length > 0) {
            
            row_items = Object.entries(registered_event_list).map(([key, data]) => {
                return (<tr key={key}>
                            <td scope="row"><Link to={'/e/'+ ((data.slug) ? data.slug: data.id)} className="show-more-link">{data.title}</Link></td>
                            <td>{helpers.displayDateTime(data)}</td>
                            <td>{helpers.uppercaseWords(data.venue_type)}</td>
                            <td>{data.type_name}</td>
                            <td>{data.category_name}</td>
                            <td>{data.reference_no ?? ''}</td>
                            <td>{helpers.displayPaymentStatusBadge(data.status ? data.status : '')}</td>
                            <td className="pending">{displayButtons(data)}</td>
                        </tr>)
            })
        }
        else{
          row_items = <tr>
                  <td colSpan="10" className='text-center'>No available data</td>
            </tr>
        }

        return row_items;
    }

    function displayButtons(data){
        let buttons = [];
        if(data.status==4){
            buttons.push(<button key="send-ticket" type="button" className="upload" style={{width: '70px'}}>Send Ticket</button>)
            {/* <button type="button" className="upload"><img src={images.uploadIcon} />Upload</button> */}
        }
        else if(data.status==2 && !data.reference_no){
            buttons.push(<button key="continue" type="button" className="retry" style={{width: '70px'}} onClick={(e) => btnAction(data, 'continue')} title="Continue Registration">Continue</button>)
        }
        else if(data.status==2 && data.reference_no){
            buttons.push(
            <><button key="update" type="button" className="retry mb-1" style={{width: '60px'}} onClick={(e) => btnAction(data, 'update-payment')}>Update</button> 
            <button key="pay" type="button" className="retry" style={{width: '60px'}} onClick={(e) => btnAction(data, 'pay-now')}>Pay Now</button> </>
            )
        }

        return buttons
    }

    function clearSearch(){
        setSearchKey('')
        getEvents()
    }

    return (
        <section className="faith">
            <div className="container">
                <Loader isLoading={loading}/>
                <div className="parent">
                    <div className="container py-4">
                        <h1>Dashboard</h1>

                        <SearchBar
                            viewer="client"
                            search_key={search_key}
                            // input_type= {input_type}
                            search_filter={search_filter} 
                            setSearchKey={setSearchKey} 
                            // setInputType={setInputType} 
                            setFilter={setFilter}
                            setLoading = {setLoading}
                            sendRequest = {sendRequest}
                            clearSearch = {clearSearch}
                            handleSearch={handleSearch}
                        />

                        {/* Login navigation */}
                        <div className="container card filter-dashboard mx-0 px-0" id="user-dashboard">
                          <nav className="navigation-login">
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                              <button className="nav-link list-events active" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false" onClick={(e)=>changeTab('registered-events')}>Registered Events</button>
                              <button className="nav-link list-events" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={(e)=>changeTab('all-events')}>Other Events</button>
                            </div>
                          </nav>
                          <div className="tab-content" id="nav-tabContent">
                            <div className="tab-pane fade px-4 pb-4 " id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                <h4 className="faith-login-title mt-3">Browse Events</h4>

                                <div className="container">
                                    <EventCards data={upcoming_event_list} empty_caption="No available event." />
                                </div>
                            </div>
                            <div className="tab-pane fade px-4 show active" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    <h4 className="faith-login-title mt-3">Registration History</h4>
                                    <div className="table-responsive">
                                      <table className="table table-hover table-responsive">
                                        <thead>
                                          <tr>
                                            <th scope="col">EVENT&nbsp;NAME</th>
                                            <th scope="col">EVENT&nbsp;DATE</th>
                                            <th scope="col">VENUE</th>
                                            <th scope="col">TYPE</th>
                                            <th scope="col">CATEGORY</th>
                                            <th scope="col" width="220">REFERENCE&nbsp;NO</th>
                                            <th scope="col">STATUS</th>
                                            <th scope="col">ACTION</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                            {tableContent(registered_event_list)}
                                        </tbody>
                                      </table>

                                      <Paginations
                                        current_page={res_data.current_page}
                                        total_page={res_data.total}
                                        per_page={res_data.per_page}
                                        changePage={changePage}
                                      />
                                    </div>
                            </div>
                          </div>
                        </div>
                        {/* End Login navigation  */}
                    </div>
                </div>
            </div>
        </section>
    )
}
 
export default DashboardClient;